import { createElement, useEffect, useRef } from "react";
import { useWordPressBar } from "../../AppProvider";

const BenefitsHeader = () => {
  const { benefitBar } = useWordPressBar();

  return benefitBar ? (
    <InnerHTML html={benefitBar.style + benefitBar.js + benefitBar.html} />
  ) : (
    <></>
  );
};

export default BenefitsHeader;

export const InnerHTML = ({ html = "<div></div>" }: { html: string }) => {
  const divRef = useRef<HTMLDivElement>(null);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (!isFirstRender.current) return;
    isFirstRender.current = false;

    const slotHtml = document.createRange().createContextualFragment(html);
    if (divRef.current) {
      divRef.current.innerHTML = "";
      divRef.current.appendChild(slotHtml);
    }
  }, [html, divRef]);

  return createElement("div", { ref: divRef });
};
